import ProductReport from './product-report.container';

export default ProductReport;